import { Model } from "@iventis/domain-model/model/model";
import { Asset } from "@iventis/domain-model/model/asset";
import { UploadModelData } from "@iventis/types/model-types";

/** Parse a Model to UploadModelData
 * Note the thumbnail here is actually the model's corresponding asset!
 */
export const convertModelToUploadModelData = (model: Model & { thumbnail: Asset }, imageUrl: string, fileUrl: string): UploadModelData => {
    const { height, width, length } = model;
    return {
        thumbnailId: model.thumbnail.id,
        modelId: model.id,
        categories: model.categories ?? model.thumbnail.tags ?? [],
        model: { fileName: model.name, modelUrl: fileUrl },
        thumbnail: { fileName: model.thumbnail.name, imageUrl },
        name: model.name,
        variableSizeModel: height != null && width != null && length != null,
        size: { height, width, length },
        customImage: model.thumbnail.metaData?.customImage ?? false,
        aspectRatio: {
            width: model?.imageAspectRatioWidth,
            height: model?.imageAspectRatioHeight,
        },
        customColour: model.thumbnail.metaData?.customColour ?? false,
    };
};
